import React, { useEffect } from 'react';
import Header from './Header';

const AboutUs = () => {
  useEffect(() => {
    document.title = 'Game Lim - About us';
  }, []);

  return (
    <>
      <Header />
      <div style={{
        maxWidth: 900,
        margin: '0 auto',
        padding: '40px 16px',
        background: 'rgba(255,255,255,0.95)',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
        marginTop: 40
      }}>
        <h1 style={{
          fontSize: 36,
          fontWeight: 800,
          color: '#ad1457',
          marginBottom: 18,
          letterSpacing: 1
        }}>
          About Gamelim.com
        </h1>
        <p style={{ fontSize: 18, color: '#444', marginBottom: 24, lineHeight: 1.7 }}>
          <b>Gamelim.com</b> is the leading destination for the community of mobile game and app enthusiasts. We provide <b>objective reviews</b>, <b>the latest news</b>, and <b>useful guides</b> about trending games and outstanding apps on Android and iOS.
        </p>
        <p style={{ fontSize: 18, color: '#444', marginBottom: 24, lineHeight: 1.7 }}>
          Our team consists of experienced reviewers, passionate about technology and always up-to-date with the latest trends. At Gamelim, you will find:
        </p>
        <ul style={{ fontSize: 18, color: '#444', marginBottom: 24, lineHeight: 1.7, paddingLeft: 24 }}>
          <li>• <b>Game Reviews:</b> In-depth, honest reviews of top games to help you choose the best titles for you.</li>
          <li>• <b>Blog & News:</b> News, in-depth analysis, gaming tips, app guides, and many other exciting topics.</li>
          <li>• <b>HTML5 Games:</b> Enjoy free HTML5 games, playable instantly in your browser without installation.</li>
        </ul>
        <p style={{ fontSize: 18, color: '#444', marginBottom: 24, lineHeight: 1.7 }}>
          We are committed to delivering <b>quality content</b>, <b>reliability</b>, and a <b>modern, user-friendly interface</b> for everyone. Gamelim.com always listens to feedback to continuously improve and better serve the community.
        </p>
        <p style={{ fontSize: 18, color: '#444', marginBottom: 18, lineHeight: 1.7 }}>
          Thank you for being with <b>Gamelim.com</b>! Explore, experience, and share with us!
        </p>
        <div style={{ marginTop: 40, color: '#888', fontSize: 16, textAlign: 'right' }}>
          &copy; 2025 gamelim.com - All Rights Reserved
        </div>
      </div>
    </>
  );
};

export default AboutUs; 